
import React, { useContext, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import SignupButton from './miniComponents/SignupButton'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'

const FourthSlide = ()=> {
    return (
        <div className = 'fourthSlide'> 
            <h1>We are going to launch soon :)</h1>
            <p>Sign up for a notification and get an access to ideafy right after the launch</p>
        </div>
    )
}

export default FourthSlide 